import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './../Transaction/Transactions.css';
import { CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain, isLoanFullView} from './../Security';
import {useTable, useSortBy} from 'react-table';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import AddCardIcon from '@mui/icons-material/AddCard';
import EditNoteIcon from '@mui/icons-material/EditNote';
import RecyclingIcon from '@mui/icons-material/Recycling';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import PreviewIcon from '@mui/icons-material/Preview';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function PagibigCalamityLoan({user, userAccess, isHideSideMenu}) {
    const [canFullView, setCanFullView] = useState(false);

    useEffect(() => {
        setCanFullView(isLoanFullView(userAccess?.description));
    }, [userAccess]);

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TransactionInfo">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Loans & Benefits >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Pagibig Calamity Loan"}</span>
                        </div>
                            <h3>Pagibig Calamity Loan</h3>
                        </div>
                        <div className="transaction-body">
                            {
                                canFullView ? 
                                <InitPagibigCalamityLoan user={user}/>
                                :
                                <InitHistoryLoanTable user={user}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
function InitPagibigCalamityLoan({user}){
    var header = [
        "Pagibig Calamity Loan Id",
        "Employee",
        "Total Loan",
        "Total Balance",
        "Default Deduction",
        "Is Active?",
        "",
    ]
    var accessor = [
        "pagibigCalamityLoanRequestId",
        "employeePersonalInformationFullName",
        "pagibigCalamityLoanRequestTotalLoan",
        "totalBalance",
        "defaultDeduction",
        "isActive",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loans, setLoans] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by employee");
    
    const [addRequestForm, setAddRequestForm] = useState(false);
    const [editRequestForm, setEditRequestForm] = useState(false);
    const [overwriteRequestForm, setOverwriteRequestForm] = useState(false);
    const [historyForm, setHistoryForm] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);

    //Add
    const [employee, setEmployee] = useState("");
    const [totalLoan, setTotalLoan] = useState("");
    const [totalBalance, setTotalBalance] = useState("");
    const [defaultDeduction, setDefaultDeduction] = useState("");
    const [isActive, setIsActive] = useState(false);

    const [oldTotalBalance, setOldTotalBalance] = useState("");
    const [oldDefaultDeduction, setOldDefaultDeduction] = useState("");

    //Confirmations
    const [newRequestConfirmationForm, setNewRequestConfirmationForm] = useState(false);
    const [editRequestConfirmationForm, setEditRequestConfirmationForm] = useState(false);
    const [recalculateRequestConfirmationForm, setRecalculateRequestConfirmationForm] = useState(false);
    const [cancelRequestConfirmationForm, setCancelRequestConfirmationForm] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/PagibigCalamityLoan";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setLoans(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);
    const fetchDataAllLoans = useCallback(async () => {
        try {
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                return response.data; // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, [apiUrl]);
    const fetchExistingLoanData = async (id) => {
        try {
            const response = await axios.get(apiUrl + `/request/existing/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if(response.data){
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return false; // Return false in case of error
        }
    };
    const fetchRequestLoanData = async (id) => {
        try {
            const response = await axios.get(apiUrl + `/request/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    useEffect(() => {
        fetchData();

        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by employee")
                break;
            case 1:
                setSearchPlaceholder("Search by pagibig calamity loan id")
                break;
            default:
                setSearchPlaceholder("Search by employee")
                break;
        }
    }, [filterDataIndex, 
        fetchData
    ]);

    useEffect(() => {
        if(addRequestForm
            || editRequestForm
            || overwriteRequestForm
        ){
            setEmployee(selectedData.employeePersonalInformationFullName);
            setTotalLoan(selectedData.pagibigCalamityLoanRequestTotalLoan);
            setTotalBalance(selectedData.totalBalance);
            setDefaultDeduction(selectedData.defaultDeduction);
            setIsActive(selectedData.isActive);

            setOldTotalBalance(selectedData.totalBalance);
            setOldDefaultDeduction(selectedData.defaultDeduction);
        }
    }, [addRequestForm, 
        editRequestForm, 
        overwriteRequestForm, 
        selectedData, 
        setTotalLoan, 
        setTotalBalance, 
        setDefaultDeduction,
        setIsActive,
    ]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const currentDate = new Date();
        var requestModel = [];
        setAddRequestForm(false);

        setLoadingRequest(true);

        const requestData = {
            employeePersonalInformationId: selectedData.employeePersonalInformationId,
            totalLoan: totalLoan,
            dateGranted: currentDate,
            dateCancelled: null,
            status: "Approved"
        };

        try {
            const response = await axios.post(apiUrl + `/request`, requestData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            requestModel = response.data;
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }

        const data = {
            pagibigCalamityLoanRequestId: requestModel.id,
            employeePersonalInformationId: selectedData.employeePersonalInformationId,
            totalBalance: totalLoan,
            defaultDeduction: defaultDeduction,
            isActive: isActive,
            remarks: ""
        };

        const allLoans = await fetchDataAllLoans();
        const loanData = allLoans.find(loan => loan.employeePersonalInformationId === selectedData.employeePersonalInformationId);

        try {
            await axios.post(apiUrl + `/createorupdate/${loanData ? loanData.id : 0}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setAddRequestForm(false);
            await SetAuditTrail({
                setupArea: "Pagibig Calamity Loan", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${employee}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData();

            setShowRequestMessage(true);
            setIsSuccess(true);
            setTotalLoan("");
            setTotalBalance("");
            setDefaultDeduction("");
            setEmployee("");
            setIsActive(false);
            setSelectedData([]);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleUpdate = async (event) => {
        event.preventDefault();
        setEditRequestForm(false);

        const data = {
            pagibigCalamityLoanRequestId: selectedData.pagibigCalamityLoanRequestId,
            employeePersonalInformationId: selectedData.employeePersonalInformationId,
            totalBalance: totalBalance,
            defaultDeduction: defaultDeduction,
            isActive: isActive,
            remarks: ""
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl + `/createorupdate/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.totalBalance !== oldTotalBalance){
                auditInfo.push({
                    setupArea: "Pagibig Calamity Loan",
                    actionTaken: "update",
                    field: "Total Balance",
                    newValue: `${data.totalBalance}`,
                    oldValue: `${oldTotalBalance}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.defaultDeduction !== oldDefaultDeduction){
                auditInfo.push({
                    setupArea: "Pagibig Calamity Loan",
                    actionTaken: "update",
                    field: "Default Deduction",
                    newValue: `${data.defaultDeduction}`,
                    oldValue: `${oldDefaultDeduction}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setEditRequestForm(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData();

            setShowRequestMessage(true);
            setIsSuccess(true);

            setTotalLoan("");
            setTotalBalance("");
            setDefaultDeduction("");
            setEmployee("");
            setIsActive(false);
            setSelectedData([]);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleRecalculate = async (event) => {
        event.preventDefault();

        setLoadingRequest(true);
        setOverwriteRequestForm(false);

        const result = await fetchRequestLoanData(selectedData.pagibigCalamityLoanRequestId);

        const recalcData = {
            employeePersonalInformationId: result.employeePersonalInformationId,
            totalLoan: result.totalLoan,
            dateGranted: result.dateGranted,
            dateCancelled: null,
            status: "Completed"
        };

        try {
            await axios.put(apiUrl + `/request/${result.id}`, recalcData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }

        const currentDate = new Date();
        var requestModel = [];

        const requestData = {
            employeePersonalInformationId: selectedData.employeePersonalInformationId,
            totalLoan: totalLoan,
            dateGranted: currentDate,
            dateCancelled: null,
            status: "Approved"
        };

        try {
            const response = await axios.post(apiUrl + `/request`, requestData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            requestModel = response.data;
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }

        const data = {
            pagibigCalamityLoanRequestId: requestModel.id,
            employeePersonalInformationId: selectedData.employeePersonalInformationId,
            totalBalance: totalLoan,
            defaultDeduction: defaultDeduction,
            isActive: isActive,
            remarks: ""
        };

        const allLoans = await fetchDataAllLoans();
        const loanData = allLoans.find(loan => loan.employeePersonalInformationId === selectedData.employeePersonalInformationId);

        try {
            await axios.post(apiUrl + `/createorupdate/${loanData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setOverwriteRequestForm(false);
            await SetAuditTrail({
                setupArea: "Pagibig Calamity Loan", 
                actionTaken: "recalculate", 
                field: "Recalculate Loan", 
                newValue: `${employee}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData();

            setShowRequestMessage(true);
            setIsSuccess(true);
            setTotalLoan("");
            setTotalBalance("");
            setDefaultDeduction("");
            setEmployee("");
            setIsActive(false);
            setSelectedData([]);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleCancel = async (event) => {
        event.preventDefault();
        const currentDate = new Date();
        const result = await fetchRequestLoanData(selectedData.pagibigCalamityLoanRequestId);

        setLoadingRequest(true);

        const requestData = {
            employeePersonalInformationId: result.employeePersonalInformationId,
            totalLoan: 0,
            dateGranted: result.dateGranted,
            dateCancelled: currentDate,
            status: "Cancelled"
        };

        try {
            await axios.put(apiUrl + `/request/${result.id}`, requestData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }

        const data = {
            pagibigCalamityLoanRequestId: selectedData.pagibigCalamityLoanRequestId,
            employeePersonalInformationId: selectedData.employeePersonalInformationId,
            totalBalance: 0,
            defaultDeduction: 0,
            remarks: ""
        };

        try {
            await axios.put(apiUrl + `/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Pagibig Calamity Loan", 
                actionTaken: "cancelled", 
                field: "Cancel Loan", 
                newValue: `${employee}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData();

            setShowRequestMessage(true);
            setIsSuccess(true);
            setTotalLoan("");
            setTotalBalance("");
            setDefaultDeduction("");
            setEmployee("");
            setSelectedData([]);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.pagibigCalamityLoanRequestId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                break;
        }

        setLoans(res);
    };

    const openAddRequestForm = async (data) => {
        const isLoanExisted = await fetchExistingLoanData(data.employeePersonalInformationId);
        
        if (isLoanExisted) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Employee has existing loan. Use recalculate instead.");
            return;
        }

        setAddRequestForm(true);
        setSelectedData(data);
    };
    const closeAddRequestForm = () =>{
        setAddRequestForm(false);
    };
    const openEditRequestForm = async (data) => {
        const isLoanExisted = await fetchExistingLoanData(data.employeePersonalInformationId);
        
        if (!isLoanExisted) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("The employee does not have current loan.");
            return;
        }

        setEditRequestForm(true);
        setSelectedData(data);
    };
    const closeEditRequestForm = () =>{
        setEditRequestForm(false);
    };
    const openOverwriteRequestForm = async (data) =>{
        const isLoanExisted = await fetchExistingLoanData(data.employeePersonalInformationId);
        
        if (!isLoanExisted) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Re-calculation failed. Please create new request instead.");
            return;
        }

        setOverwriteRequestForm(true);
        setSelectedData(data);
    };
    const closeOverwriteRequestForm = () =>{
        setOverwriteRequestForm(false);
    };

    const openNewRequestConfirmationForm = () =>{
        setNewRequestConfirmationForm(true);
    }
    const closeNewRequestConfirmationForm = () =>{
        setNewRequestConfirmationForm(false);
    };
    const openEditRequestConfirmationForm = () =>{
        setEditRequestConfirmationForm(true);
    }
    const closeEditRequestConfirmationForm = () =>{
        setEditRequestConfirmationForm(false);
    };
    const openRecalculateRequestConfirmationForm = () =>{
        setRecalculateRequestConfirmationForm(true);
    }
    const closeRecalculateRequestConfirmationForm = () =>{
        setRecalculateRequestConfirmationForm(false);
    };
    const openCancelRequestConfirmationForm = async (data) =>{
        const result = await fetchRequestLoanData(data.pagibigCalamityLoanRequestId);
        
        if (!result) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No existing loans to be cancelled.");
            return;
        }

        if (result && result.pagibigCalamityLoanLogs.length > 0 ) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Unable to cancel loan. There is already transaction with this loan.");
            return;
        }

        setCancelRequestConfirmationForm(true);
        setSelectedData(data);
    }
    const closeCancelRequestConfirmationForm = () =>{
        setCancelRequestConfirmationForm(false);
    };
    const openHistoryForm = (data) =>{
        setHistoryForm(true);
        setSelectedData(data);
    };
    const closeHistoryForm = () =>{
        setHistoryForm(false);
    };

    return(
        <>
            {FilterPagibigCalamity(setFilterDataIndex)}
            <div className="transaction-body-top row" style={{justifyContent:"space-between"}}>
            {CreateSearchBarWithPlaceHolder("", "transaction-search row", "transaction-search-icon", "transaction-search-input", (e) => handleFilter(e.target.value), searchPlaceholder, SearchIcon)}
            </div>
            <div className="transaction-table container">
                <CreateTable
                    dataList={loans}
                    dataHeader={header}
                    dataAccessor={accessor}
                    addRequest={openAddRequestForm} 
                    editRequest={openEditRequestForm} 
                    overwriteRequest={openOverwriteRequestForm} 
                    deleteRequest={openCancelRequestConfirmationForm} 
                    viewRequest={openHistoryForm}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </div>
            <AddRequestForm  isOpen={addRequestForm} 
                    onClose={closeAddRequestForm}
                    employee={employee}
                    setEmployee={setEmployee}
                    totalBalance={totalBalance}
                    setTotalBalance={setTotalBalance}
                    totalLoan={totalLoan}
                    setTotalLoan={setTotalLoan}
                    defaultDeduction={defaultDeduction}
                    setDefaultDeduction={setDefaultDeduction}
                    isActive={isActive}
                    setIsActive={setIsActive}
                    handleSubmit={openNewRequestConfirmationForm}
            >
            </AddRequestForm>
            <EditRequestForm  isOpen={editRequestForm} 
                    onClose={closeEditRequestForm}
                    employee={employee}
                    setEmployee={setEmployee}
                    totalBalance={totalBalance}
                    setTotalBalance={setTotalBalance}
                    totalLoan={totalLoan}
                    setTotalLoan={setTotalLoan}
                    defaultDeduction={defaultDeduction}
                    setDefaultDeduction={setDefaultDeduction}
                    isActive={isActive}
                    setIsActive={setIsActive}
                    handleSubmit={openEditRequestConfirmationForm}
            >
            </EditRequestForm>
            <OverwriteRequestForm  isOpen={overwriteRequestForm} 
                    onClose={closeOverwriteRequestForm}
                    employee={employee}
                    setEmployee={setEmployee}
                    totalBalance={totalBalance}
                    setTotalBalance={setTotalBalance}
                    totalLoan={totalLoan}
                    setTotalLoan={setTotalLoan}
                    defaultDeduction={defaultDeduction}
                    setDefaultDeduction={setDefaultDeduction}
                    isActive={isActive}
                    setIsActive={setIsActive}
                    handleSubmit={openRecalculateRequestConfirmationForm}
            >
            </OverwriteRequestForm>
            <NewRequestConfirmation  isOpen={newRequestConfirmationForm} 
                    onClose={closeNewRequestConfirmationForm}
                    submit={handleSubmit}
            >
            </NewRequestConfirmation>
            <EditRequestConfirmation  isOpen={editRequestConfirmationForm} 
                    onClose={closeEditRequestConfirmationForm}
                    submit={handleUpdate}
            >
            </EditRequestConfirmation>
            <RecalculateRequestConfirmation  isOpen={recalculateRequestConfirmationForm} 
                    onClose={closeRecalculateRequestConfirmationForm}
                    submit={handleRecalculate}
            >
            </RecalculateRequestConfirmation>
            <CancelRequestConfirmation  isOpen={cancelRequestConfirmationForm} 
                    onClose={closeCancelRequestConfirmationForm}
                    submit={handleCancel}
            >
            </CancelRequestConfirmation>
            <HistoryLoan  isOpen={historyForm} 
                    onClose={closeHistoryForm}
                    selectedData={selectedData}
            >
            </HistoryLoan>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </>
    )
}
function FilterPagibigCalamity(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "PagibigCalamityLoanId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="PagibigCalamityLoanId">Pagibig Calamity Loan Id</option>
            </select>
        </div>
    );
};
function AddRequestForm({
    isOpen, 
    onClose,
    employee,
    setEmployee,
    totalBalance, 
    setTotalBalance,
    totalLoan, 
    setTotalLoan,
    defaultDeduction, 
    setDefaultDeduction,
    isActive,
    setIsActive,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!totalLoan || !defaultDeduction){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployee("");
        setTotalBalance("");
        setTotalLoan("");
        setDefaultDeduction("");
        setErrorState(false);
        setIsActive(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Loan Request</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                placeholder="Employee"
                                value={employee}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Balance</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                type='number'
                                placeholder="Total Balance"
                                value={totalBalance}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                onChange={(e) => setTotalBalance(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Loan</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                placeholder="Total Loan"
                                value={totalLoan}
                                onChange={(e) => setTotalLoan(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !totalLoan && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Deduction</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                placeholder="Total Deduction"
                                value={defaultDeduction}
                                onChange={(e) => setDefaultDeduction(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !defaultDeduction && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(e)=>setIsActive(e.target.checked)}/>
                            </div>
                            <span style={{
                                    visibility: "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                ADD REQUEST
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditRequestForm({
    isOpen, 
    onClose,
    employee,
    setEmployee,
    totalBalance, 
    setTotalBalance,
    totalLoan, 
    setTotalLoan,
    defaultDeduction, 
    setDefaultDeduction,
    isActive,
    setIsActive,
    handleSubmit}) 
{

    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!defaultDeduction){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployee("");
        setTotalBalance("");
        setTotalLoan("");
        setDefaultDeduction("");
        setIsActive(false);
        setErrorState(false);
    };
    /* const handleEdit = () =>{
        const data = {
        };

        handleSubmit(data);
    } */
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Edit Loan Request</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                placeholder="Employee"
                                value={employee}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Balance</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                type='number'
                                placeholder="Total Balance"
                                value={totalBalance}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                onChange={(e) => setTotalBalance(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility:"hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Loan</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                type='number'
                                placeholder="Total Loan"
                                value={totalLoan}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                onChange={(e) => setTotalLoan(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility:"hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Deduction</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                placeholder="Total Deduction"
                                value={defaultDeduction}
                                onChange={(e) => setDefaultDeduction(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !defaultDeduction && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(e)=>setIsActive(e.target.checked)}/>
                            </div>
                            <span style={{
                                    visibility: "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                EDIT REQUEST
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function OverwriteRequestForm({
    isOpen, 
    onClose,
    employee,
    setEmployee,
    totalBalance, 
    setTotalBalance,
    totalLoan, 
    setTotalLoan,
    defaultDeduction, 
    setDefaultDeduction,
    isActive,
    setIsActive,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!totalLoan || !defaultDeduction){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployee("");
        setTotalBalance("");
        setTotalLoan("");
        setDefaultDeduction("");
        setIsActive(false);
        setErrorState(false);
    };
    /* const handleOverwrite = () =>{
        const data = {
        };

        handleSubmit(data);
    } */
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Overwrite Loan Request</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                placeholder="Employee"
                                value={employee}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Balance</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                type='number'
                                placeholder="Total Balance"
                                value={totalBalance}
                                style={{cursor:"not-allowed", color:"rgba(0, 0, 0, 0.356)"}}
                                onChange={(e) => setTotalBalance(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Loan</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                placeholder="Total Loan"
                                value={totalLoan}
                                onChange={(e) => setTotalLoan(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !totalLoan && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Total Deduction</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                placeholder="Total Deduction"
                                value={defaultDeduction}
                                onChange={(e) => setDefaultDeduction(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !defaultDeduction && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(e)=>setIsActive(e.target.checked)}/>
                            </div>
                            <span style={{
                                    visibility: "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                OVERWRITE REQUEST
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, addRequest, editRequest, overwriteRequest, deleteRequest, viewRequest }) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            addRequest, 
                                            editRequest, 
                                            overwriteRequest, 
                                            deleteRequest, 
                                            viewRequest)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function CreateTableForLoanHistory({ dataList = [], dataHeader = [], dataAccessor = [], addRequest, editRequest, overwriteRequest, deleteRequest, viewRequest }) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            addRequest, 
                                            editRequest, 
                                            overwriteRequest, 
                                            deleteRequest, 
                                            viewRequest)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo(header, _cell, addRequest, editRequest, overwriteRequest, deleteRequest, viewRequest) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Add Request">
                        <div className='add' style={{padding:"0 5px", marginRight:"5px"}} onClick={()=>addRequest(data)}><AddCardIcon/></div>
                    </Tooltip>
                    <Tooltip text="Edit">
                        <div className='edit' style={{padding:"0 5px", marginRight:"5px"}} onClick={()=>editRequest(data)}><EditNoteIcon/></div>
                    </Tooltip>
                    <Tooltip text="Recalculate">
                        <div className='recycle' style={{padding:"0 5px", marginRight:"5px"}} onClick={()=>overwriteRequest(data)}><RecyclingIcon/></div>
                    </Tooltip>
                    <Tooltip text="Delete">
                        <div className='delete' style={{padding:"0 5px", marginRight:"5px"}} onClick={()=>deleteRequest(data)}><DeleteSweepIcon/></div>
                    </Tooltip>
                    <Tooltip text="History">
                        <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={()=>viewRequest(data)}><PreviewIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    if(header === "Is Active?"){
        const value = _cell.render("Cell").props.value;

        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={value}
                    disabled={true}
                />
            </td>
        )
    }

    if (header === "Manage") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="History">
                        <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={()=>viewRequest(data)}><PreviewIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    if(header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Total Amount"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    if(header === "Request Date"
        || header === "Processed Date"
    ){
        const value = _cell.render("Cell").props.value
        const date = new Date(value);

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '80%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function NewRequestConfirmation({isOpen, 
    onClose, 
    submit}
){
    const handleClose = () => {
        onClose();
    };
    const handleSubmit = (e) =>{
        handleClose();
        submit(e);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Do you want to create new requests?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>handleSubmit(e)}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditRequestConfirmation({isOpen, 
    onClose, 
    submit}
){
    const handleClose = () => {
        onClose();
    };

    const handleSubmit = (e) =>{
        handleClose();
        submit(e);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Do you want to save new deduction?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>handleSubmit(e)}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function RecalculateRequestConfirmation({isOpen, 
    onClose, 
    submit}
){
    const handleClose = () => {
        onClose();
    };

    const handleSubmit = (e) =>{
        handleClose();
        submit(e);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Do you want to save the recalculation you made?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>handleSubmit(e)}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function CancelRequestConfirmation({isOpen, 
    onClose, 
    submit}
){
    const handleClose = () => {
        onClose();
    };

    const handleSubmit = (e) =>{
        handleClose();
        submit(e);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Do you want to cancel loan?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>handleSubmit(e)}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function HistoryLoan({isOpen, 
    onClose, 
    selectedData}
){
    var header = [
        "Employee Id",
        "Employee",
        "Processed Date",
        "Total Amount",
        "Status",
    ]
    var accessor = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "processedDate",
        "amount",
        "status",
    ]

    const [loading, setLoading] = useState(false);
    const [loans, setLoans] = useState(false);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/PagibigCalamityLoan/loan-logs";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}/${selectedData.employeePersonalInformationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                console.log(response.data)
                setLoans(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [selectedData]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen]);

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Loan History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForLoanHistory
                                dataList={loans ? loans : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {loans.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function InitHistoryLoanTable({user}){
    var header = [
        "Pagibig Calamity Loan Id",
        "Employee",
        "Total Loan",
        "Total Balance",
        "Default Deduction",
        "Is Active?",
        "Manage",
    ]
    var accessor = [
        "pagibigCalamityLoanRequestId",
        "employeePersonalInformationFullName",
        "pagibigCalamityLoanRequestTotalLoan",
        "totalBalance",
        "defaultDeduction",
        "isActive",
        "manage"
    ]

    const [loading, setLoading] = useState(false);
    const [loans, setLoans] = useState(false);
    const [historyForm, setHistoryForm] = useState(false);
    const [selectedData, setSelectedData] = useState([]);

    const openHistoryForm = (data) =>{
        setSelectedData(data);
        setHistoryForm(true);
    }
    const closeHistoryForm = () =>{
        setHistoryForm(false);
    }

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/PagibigCalamityLoan";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            const finalData = response.data.filter(data => data.employeePersonalInformationId === user.employeePersonalInformationId);
            setLoans(finalData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <div className="transaction-table container">
                <CreateTableForLoanHistory
                    dataList={loans ? loans : []}
                    dataHeader={header}
                    dataAccessor={accessor}
                    viewRequest={openHistoryForm}
                />
                {loans.length > 0 ? (
                    <div></div>
                )
                :
                (
                    <div>
                    {loading ? (
                        <div
                            style={{
                            position: "fixed",
                            top: "0",
                            left: "0",
                            width: "100vw",
                            height: "100vh",
                            zIndex: "2000",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            backgroundColor: "#ffffff59",
                            }}
                        >
                            <img src={loadingSpinner} alt="Loading..." />
                        </div>
                    ) : (
                            <div> {/*<p>No records to display</p>*/}</div>
                        )
                    }
                    </div>
                )}
            </div>
            <HistoryLoan  isOpen={historyForm} 
                    onClose={closeHistoryForm}
                    selectedData={selectedData}
            >
            </HistoryLoan>
        </>
    );
}
export default PagibigCalamityLoan
